var PES = PES || {};
PES.PlayPauseVideo = function () {

    function playPauseVideo() {

        var modalWindow = "#video-modal";
        var playerIframe = ".video__container > iframe.video-player";
        var videoId = $(playerIframe).attr("data-video");
        var openModalVideo = ".js-open-modal.video-open";

        function waitForVideo(callback) {
            setTimeout(callback, 10);
        };

        function checkVideo() {
            if ($(modalWindow).hasClass("play-video")) {
                $(playerIframe).attr('src', 'https://player.vimeo.com/video/' + videoId + '?autoplay=1');
            } else {
                $(playerIframe).attr('src', ' ');
            }
        }

        $(openModalVideo).on("click", function () {
            waitForVideo(checkVideo);
        });

        $("body").on("click", function (e) {
            var target = e.target;

            if ($(target).hasClass("video-open")) {
                $(modalWindow).addClass("play-video");
                waitForVideo(checkVideo);
            } else if ($(target).hasClass("close-button") || (!$(target).closest("modal__box").length && !$(target).hasClass("modal__box"))) {
                $(modalWindow).removeClass("play-video");
                waitForVideo(checkVideo);
            }
        });
    };

    var init = function () {
        playPauseVideo();
    };

    return {
        init: init
    };
}();